/**
 * PersonDropdown
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../../../workspaces/react-router-selectors';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    clearPageOnChange?: boolean;
    updateQueryString: Function;
    people?: string | string[];
    options: {
        key: number,
        text: string,
        value: number
    }[];
    multiple: boolean;
}

export class PersonDropdown extends React.Component<Props> {
    handleChange = (
        event: SyntheticInputEvent<EventTarget>,
        data: { value: number }
    ) => {
        const { clearPageOnChange } = this.props;
        this.props.updateQueryString({
            ...(clearPageOnChange ? { page: undefined } : {}),
            people: data.value || undefined,
            selectedEvent: undefined
        });
    };

    render() {
        const { people, options, multiple } = this.props;
        return (
            <Dropdown
                placeholder="All People"
                search
                selection
                value={people || null}
                clearable
                selectOnBlur={false}
                options={options}
                onChange={this.handleChange}
                lazyLoad
                multiple={multiple}
                closeOnChange
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    people: makeSelectQueryStringValue('people'),
    options: selectOptions
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(PersonDropdown);
